import { render, staticRenderFns } from "./theme2.vue?vue&type=template&id=403e00e9&"
import script from "./theme2.vue?vue&type=script&lang=ts&"
export * from "./theme2.vue?vue&type=script&lang=ts&"
import style0 from "./theme2.vue?vue&type=style&index=0&id=403e00e9&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports